import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  SkyCoachContext,
  SkyCoachState,
  SkyCoachStateService,
} from '../service/sky/sky-coach-state.service';
import { SkyCharacterComponent } from './sky-character.component';

@Component({
  selector: 'app-sky-coach-panel',
  standalone: true,
  imports: [CommonModule, SkyCharacterComponent],
  templateUrl: './sky-coach-panel.component.html',
  styleUrl: './sky-coach-panel.component.css',
})
export class SkyCoachPanelComponent implements OnChanges {
  @Input({ required: true }) context!: SkyCoachContext;
  @Input() kicker = 'Coach';
  @Input() title = 'Sky';
  @Input() layout: 'card' | 'inline' | 'compact' | 'result' = 'card';
  @Input() framed = false;

  protected state: SkyCoachState = { pose: 'welcome', message: '' };
  protected playSituation = false;

  constructor(private skyCoachState: SkyCoachStateService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['context']) {
      return;
    }
    this.refreshState();
  }

  private refreshState(): void {
    const next = this.skyCoachState.resolve(this.context ?? {});
    if (
      next.pose === this.state.pose
      && next.message === this.state.message
      && next.statusLabel === this.state.statusLabel
    ) {
      return;
    }
    this.playSituation = this.skyCoachState.shouldPlaySituation(this.context ?? {}, next);
    this.state = next;
  }
}
